import { useEffect, useState } from "react";
import { layout, site } from "../../siteConfig";
import type { IndustryContent } from "../../content/industry";
import { ThemeToggle } from "../layout/ThemeToggle";

/**
 * Encabezado con tres variantes: «compact» (barra de datos + menú corporativo), «centered» (logotipo al centro y menú
 * repartido) y «transparent» (sobre la portada; se vuelve sólido al desplazarse). En móvil el menú se abre en un panel.
 */
export function SiteHeader({ header, nav }: Pick<IndustryContent, "header" | "nav">) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    if (header.variant !== "transparent") return;
    const update = () => setScrolled(window.scrollY > 40);
    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, [header.variant]);
  const half = Math.ceil(nav.length / 2);
  const links = (items: typeof nav) => items.map(link => <li key={link.href}><a href={link.href} onClick={() => setOpen(false)}>{link.label}</a></li>);
  const classes = ["ix-header", `ix-header--${header.variant}`, layout.headerPosition === "sticky" ? "is-sticky" : "", scrolled ? "is-solid" : "", open ? "is-open" : ""];
  return (
    <header className={classes.filter(Boolean).join(" ")}>
      {header.topbar.length > 0 && <div className="ix-topbar"><div className="ix-container">{header.topbar.map(item => <span key={item}>{item}</span>)}</div></div>}
      <div className="ix-container ix-header-bar">
        <a className="ix-brand" href="#inicio" aria-label={`${site.name}, ir al inicio`}>
          <span className="ix-brand-mark" aria-hidden="true" style={site.logo ? { background: 'transparent', boxShadow: 'none', borderRadius: 0 } : undefined}>
            {site.logo ? <img src={site.logo} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : site.name.slice(0, 1)}
          </span>
          <span className="ix-brand-name">{site.name}</span>
        </a>
        <button type="button" className="ix-menu-toggle" aria-expanded={open} aria-controls="ix-navigation" onClick={() => setOpen(value => !value)}>
          <span className="ix-sr-only">{open ? "Cerrar menú" : "Abrir menú"}</span>
          <span aria-hidden="true" className="ix-menu-icon" />
        </button>
        <nav id="ix-navigation" className="ix-nav" aria-label="Principal">
          {header.variant === "centered"
            ? <><ul className="ix-nav-start">{links(nav.slice(0, half))}</ul><ul className="ix-nav-end">{links(nav.slice(half))}</ul></>
            : <ul>{links(nav)}</ul>}
          <a className="ix-button ix-button--primary ix-header-cta" href={header.cta.href} onClick={() => setOpen(false)}>{header.cta.label}</a>
        </nav>
        <ThemeToggle className="theme-toggle ix-theme-toggle" />
      </div>
    </header>
  );
}
